import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import "leaflet/dist/leaflet.css"

const MapPopup = ({ open, setOpen, scan }) => {

  const close = () => setOpen(false)

  if (scan) return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "650px",
            maxWidth: "650px",
          },
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        Location where pass was scanned : {scan.ts}
      </DialogTitle>

      <DialogContent>
        <div style={{ width: 600, height: 400 }} className="overflow-auto">
          <MapContainer center={[scan.position.x, scan.position.y]} zoom={15} scrollWheelZoom={true}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[scan.position.x, scan.position.y]} />
          </MapContainer>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <div/>
          <Button variant="outlined" onClick={close}>Close</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default MapPopup